// extracted by mini-css-extract-plugin
export var cardIcon = "_aq-4";
export var checkboxCard = "_aq-0";
export var checkboxCardSelected = "_aq-3";
export var disabled = "_aq-1";
export var outerBorder = "_aq-2";
export var spacerMedium = "_aq-7";
export var spacerSmall = "_aq-6";
export var spacerXsmall = "_aq-5";